import React from 'react';
  
// Creating the context object and passing the default values.
const ActiveContext = React.createContext();
  
export default ActiveContext;